import { render, staticRenderFns } from "./MyAttention.vue?vue&type=template&id=c6b47370&scoped=true&"
import script from "./MyAttention.vue?vue&type=script&lang=js&"
export * from "./MyAttention.vue?vue&type=script&lang=js&"
import style0 from "./MyAttention.vue?vue&type=style&index=0&id=c6b47370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b47370",
  null
  
)

export default component.exports